import React, { useContext, useState } from "react";
import {
  Input,
  Button,
  Select,
  message,
  Checkbox,
  Form,
  notification,
} from "antd";
import { ClipLoader } from "react-spinners";
import "./style.css";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { createUser } from "../../../API/Admin/user";
import { UserContext } from "../../../App";
const { Option } = Select;

const AddNewUser = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const role = Form.useWatch("role", form);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      const response = await createUser(
        values?.fullName,
        values?.email,
        values?.phone,
        values?.role,
        values?.status,
        values?.password,
        values?.confirmPassword,
        values?.permissions,
      );

      if (response?.data) {
        const newUser = response.data;
        setUsers((prevUsers) => [...prevUsers, newUser]);
        messageApi.success("User created successfully!");
        form.resetFields();
        setIsModalVisible(false);
        setTimeout(() => {
          navigate("/all-users");
        }, 1000);
      }
    } catch (error) {
      const data = error?.response?.data;

      if (data && typeof data === "object") {
        const formattedMessage = Object.entries(data)
          .map(([field, messages]) => {
            const msgString = Array.isArray(messages)
              ? messages.join(", ")
              : messages;
            return `[${field}] ${msgString}`;
          })
          .join("\n");

        messageApi.error({
          content: formattedMessage,
          style: { whiteSpace: "pre-line" },
          duration: 7,
        });
      } else {
        messageApi.error("Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSaved(false);
    message.info("Changes canceled");
  };

  return (
    <div className="new-user">
      {contextHolder}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          permissions: ["monitoring", "security", "geoenforcing", "customer"],
        }}
      >
        <div className="add-new-user">
          <div className="heading">Create New User Account</div>

          <div className="user-details">
            <div className="input-group">
              <div className="title">Full Name</div>
              <Form.Item
                name="fullName"
                rules={[{ required: true, message: "Please enter full name!" }]}
              >
                <Input placeholder="Enter Full Name" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Email Address</div>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please enter email!" },
                  { type: "email", message: "Enter a valid email!" },
                ]}
              >
                <Input placeholder="Enter Email Address" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Phone Number (Optional)</div>
              <Form.Item name="phone">
                <PhoneInput
                  country={"jm"}
                  placeholder="+1 (876) 123-4567"
                  inputClass="phone-input"
                  specialLabel={false}
                  onChange={(value) => {
                    form.setFieldsValue({
                      phone: value.startsWith("+") ? value : `+${value}`,
                    });
                  }}
                />
              </Form.Item>
            </div>
          </div>

          <div className="user-details">
            <div className="input-group">
              <div className="title">Role</div>
              <Form.Item
                name="role"
                rules={[{ required: true, message: "Please select role!" }]}
              >
                <Select placeholder="Select Role">
                  <Option value="admin">Admin</Option>
                  <Option value="user">User</Option>
                </Select>
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Status</div>
              <Form.Item
                name="status"
                rules={[{ required: true, message: "Please select status!" }]}
              >
                <Select placeholder="Select Status">
                  <Option value="Active">Active</Option>
                  <Option value="Inactive">Inactive</Option>
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="user-details">
            <div className="input-group">
              <div className="title">Password</div>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Please enter password!" }]}
              >
                <Input.Password placeholder="Enter Password" />
              </Form.Item>
            </div>

            <div className="input-group">
              <div className="title">Confirm Password</div>
              <Form.Item
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please confirm password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!"),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>
            </div>
          </div>
        </div>

        {role === "user" && (
          <div className="permissions">
            <div className="heading">Role Base Permissions</div>
            <div className="checkbox-row">
              <Form.Item
                name="permissions"
                rules={[
                  {
                    required: true,
                    message: "Please select at least one permission!",
                  },
                ]}
              >
                <Checkbox.Group
                  options={[
                    { label: "Monitoring", value: "monitoring" },
                    { label: "Security & Incidents", value: "security" },
                    { label: "Geoenforcing", value: "geoenforcing" },
                    { label: "Customer Management", value: "customer" },
                  ]}
                />
              </Form.Item>
            </div>
          </div>
        )}

        <div className="form-actions">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            loading={loading}
            className="save-user"
            type="primary"
            htmlType="submit"
          >
            Save New User
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddNewUser;
